export default "__VITE_ASSET__D5aPsum6__"